import pl from "@locales/patient/shared/pl.json";
import en from "@locales/patient/shared/en.json";

export default {
  pl: pl,
  en: en,
};
